import { http } from './http';
import { defineQuery, invalidateQueries } from './queryCache';
const base = '/pages-api/pages';
const changed = response => { invalidateQueries('pages', { discard: true }); return response.data; };
const analytics = defineQuery('page-analytics', ({ slug, params }) => http.get(`${base}/${slug}/analytics`, { params }).then(r => r.data));
const leads = defineQuery('page-leads', ({ slug, params }) => http.get(`${base}/${slug}/leads`, { params }).then(r => r.data));
export const companyPages = {
  list: defineQuery('pages', () => http.get(base).then(r => r.data.pages), { ttl: 60000 }),
  get: slug => http.get(`${base}/${slug}`).then(r => r.data),
  create: (slug, page) => http.post(base, { slug, page }).then(changed),
  save: (slug, revision, page) => http.put(`${base}/${slug}`, { revision, page }).then(changed),
  publish: (slug, revision) => http.post(`${base}/${slug}/publish`, { revision }).then(changed),
  unpublish: (slug, revision) => http.post(`${base}/${slug}/unpublish`, { revision }).then(changed),
  remove: (slug, revision) => http.delete(`${base}/${slug}`, { data: { revision } }).then(r => { invalidateQueries('page-analytics', { discard: true }); invalidateQueries('page-leads', { discard: true }); return changed(r); }),
  analytics: (slug, params, options) => analytics({ slug, params }, options),
  leads: (slug, params, options) => leads({ slug, params }, options),
  deleteLead: (slug, key) => http.delete(`${base}/${slug}/leads`, { data: { key } }).then(r => { invalidateQueries('page-leads', { discard: true }); return r.data; }),
  upload: async (file, slug) => {
    const { data } = await http.post('/pages-api/assets', { contentType: file.type, size: file.size, ...(slug ? { slug } : {}) });
    const form = new FormData();
    Object.entries(data.fields).forEach(([key, value]) => form.append(key, value));
    form.append('file', file);
    const response = await fetch(data.url, { method: 'POST', body: form });
    if (!response.ok) throw new Error('Não foi possível enviar a imagem. Tente novamente.');
    return data.imageUrl;
  },
};
export const pageError = error => error.response?.data?.error || (!error.isAxiosError && error.message) || 'Não foi possível conectar ao serviço de páginas. Tente novamente.';
companyPages.analytics.peek = (slug, params) => analytics.peek({ slug, params });
companyPages.leads.peek = (slug, params) => leads.peek({ slug, params });
